import { render } from "./PrpTherapy.vue?vue&type=template&id=70fe1497"
import script from "./PrpTherapy.vue?vue&type=script&lang=js"
export * from "./PrpTherapy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__